import { string, func } from 'prop-types'

export const propTypes = {
  message: string,
  prompt: string,
  onClick: func
}
